"use strict";

(function () {

    $.widget('khis.dashboardList', {
        options: {
            filterBtnLabel: 'Filtrar'
        },
        _create: function () {

            this.header = this._createHeader();

            this.header
                .appendTo(this.element);

        },
        _init: function () {
            debug.log('_init');
        },
        _destroy: function () {
            debug.log('_destroy');
        },
        _setOption: function (key, value) {
            debug.log('_setOption', key, value);
        },
        _createHeader: function(){
            var _header = $('<div role="header" class="dashboard_header"></div>');

            $('<div class="header_nav_left_ct"><button type="button" role="nav_left" class="k_btn arrow_w_btn header_nav_left"></button></div>')
                .appendTo(_header);

            $('<div class="header_nav_right_ct"><button type="button" role="nav_right" class="k_btn arrow_e_btn header_nav_right"></button></div>')
                .appendTo(_header);

            $('<div class="push_btn header_push_btn" data-target="#filter-bar"><span class="float_left header_push_btn_label">'+this.options.filterBtnLabel+'</span><span class="ui-icon ui-icon-search float_left header_push_btn_icon"></span></div>')
                .appendTo(_header);

            $('<div id="" class="bootstrap filter_ct"></div>')
                .appendTo(_header);


            return _header;
        },
        // Public API
        refresh: function() {

        }
    });

})();